const common = {
    sso: {
        ENABLED: true,
        COOKIE_NAME: 'TR_AUTH_SAML_TOKEN',
        IDP_ENDPOINT: 'https://auth.aesculap.extranet.bbraun.com/AuthenticationService/service/saml/login/getSAMLLogin'
    },
    app: {
        URL: ''
    },
    apiGateway: {
        URL: ''
    }
}

const dev = {
    sso: {
        ENABLED: false
    },
    app: {
        URL: 'http://local.mediaprojects.aesculap.extranet.bbraun.com/'
    },
    apiGateway: {
        URL: 'https://ox1k5eqq24.execute-api.eu-central-1.amazonaws.com/api/'
    }
};

const test = {
    app: {
        URL: 'https://qas.mediaprojects.aesculap.extranet.bbraun.com/'
    },
    apiGateway: {
        URL: 'https://ox1k5eqq24.execute-api.eu-central-1.amazonaws.com/api/'
    }
}

const prod = {
    app: {
        URL: 'https://mediaprojects.aesculap.extranet.bbraun.com/'
    },
    apiGateway: {
        URL: 'https://n03sgpmso7.execute-api.eu-central-1.amazonaws.com/api/'
    }
};

const config = process.env.REACT_APP_STAGE === 'PROD'
    ? prod
    : process.env.REACT_APP_STAGE === 'TEST'
    ? test
    : dev;

export default {
    ...common,
    ...config
};



// WEBPACK FOOTER //
// ./src/config.js